import { createContext, ReactNode, useContext, useMemo, useState } from "react";

type CommandPaletteContextValue = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const CommandPaletteContext = createContext<CommandPaletteContextValue>({
  isOpen: false,
  setIsOpen: () => {},
});

export const CommandPaletteProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const value = useMemo(() => ({ isOpen, setIsOpen }), [isOpen]);

  return (
    <CommandPaletteContext.Provider value={value}>
      {children}
    </CommandPaletteContext.Provider>
  );
};

export const useCommandPalette = (): CommandPaletteContextValue =>
  useContext(CommandPaletteContext);
